import { useDispatch, useSelector } from 'react-redux';
import styles from '../css/PhotoCard.module.css';
import updateImg from '../statics/images/update.png';
import deleteImg from '../statics/images/delete.png';
import { photofolioActions, deleteImgfromAlbum, photofolioSelector} from '../redux/reducers/reducers';


export function PhotoCard({ imgOBJ, index, filteredImages }) {
    const dispatch = useDispatch();

    const {currentAlbumOBJ} = useSelector(photofolioSelector);

    const deleteImgfromAlbumHandle = () => {
        dispatch(deleteImgfromAlbum(index));
    };

    const updateHandle = async () => {
        const imgDetails = { text: imgOBJ.text, url: imgOBJ.url, index: index };
        await dispatch(photofolioActions.currImgCardUpdateHandle(imgDetails));
        
        dispatch(photofolioActions.updateImgFormToggleHandle(true));
        dispatch(photofolioActions.handleImageFormToggleByArg(false));
    };

    const onClickHandle = () => {
        const originalIndex = currentAlbumOBJ.images.findIndex(img => img === filteredImages[index]);
        console.log('originalIndex ',originalIndex);
        dispatch(photofolioActions.currImgIdxtoDispalayHandle(originalIndex));

        dispatch(photofolioActions.viewImageToggleHandle(true));
    };


    return (
        <div className={styles.card}>
            <img src={imgOBJ.url} alt='Image' id={styles.image} onClick={onClickHandle} />
            <span id={styles.text}>{imgOBJ.text}</span>

            <div className={styles.updateDiv} onClick={updateHandle}>
                <img src={updateImg} alt='Update' className={styles.icon} />
            </div>
            <div className={styles.deleteDiv} onClick={deleteImgfromAlbumHandle}>
                <img src={deleteImg} alt='Delete' className={styles.icon} />
            </div>
        </div>
    );
}
